module.exports = __webpack_public_path__ + "static/media/caterpillar.0440607b.jpg";